import axios from "axios";
import { userDataLocalStorage } from "../../../general/functions/base64Function";
import {
  SESSION_ROOM_LEAVE_TRUE,
  SESSION_ROOM_METHOD_CLOSE,
  SMVM_SET_END_SESSION_FAIL,
  SMVM_SET_END_SESSION_REQUEST,
  SMVM_SET_END_SESSION_RESET,
  SMVM_SET_END_SESSION_SUCCESS,
} from "../constants/SessionMethodConstants";
import { API_SET_END_SESSION } from "../init/api_url";

export const CloseSessionRoom = () => async (dispatch) => {
  dispatch({
    type: SESSION_ROOM_METHOD_CLOSE,
  });
};

export const RSetEndSession = () => async (dispatch) => {
  dispatch({
    type: SMVM_SET_END_SESSION_RESET,
  });
};

export const SetLeaveSession = () => async (dispatch) => {
  dispatch({
    type: SESSION_ROOM_LEAVE_TRUE,
  });
};

export const SetEndSession = () => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  // let sessionId = d[2];
  let projectCode = [d[0], d[1]].join("-");

  try {
    dispatch({
      type: SMVM_SET_END_SESSION_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data: data } = await axios.post(
      API_SET_END_SESSION(projectCode, session),
      {},
      config
    );

    dispatch({
      type: SMVM_SET_END_SESSION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: SMVM_SET_END_SESSION_FAIL,
      payload: message,
    });
  }
};
